import { flare } from "@flareapp/flare-client";

if (process.env.NODE_ENV === 'production') {
    flare.light('jw7rtJosRCNeH8ahUdATEQ4Xgz6dd61D');
    flare.addContext('Version', '2.1.2');
    flare.addContext('User Agent', window.navigator.userAgent.toLowerCase());
    flare.addContext('URL', window.location.href);
}

/**
 * Axios
 */
window.axios = require('axios');

/**
 * dayjs
 */
window.dayjs = require('dayjs');
var utc = require('dayjs/plugin/utc');
dayjs.extend(utc);
var objectSupport = require('dayjs/plugin/objectSupport');
dayjs.extend(objectSupport);

/**
 * Vue.js
 */
window.Vue = require('vue');
Vue.config.productionTip = false;

/**
 * input masking
 */
import Inputmask from 'inputmask';
Vue.directive('input-mask', {
    bind: function(el) {
        new Inputmask().mask(el);
    },
});

/**
 * v-click-outside directive
 */
import vClickOutside from 'v-click-outside';
Vue.use(vClickOutside)

/**
 * Flare driver for Vue.js
 */
import { flareVue } from '@flareapp/flare-vue';
Vue.use(flareVue);

/**
 * v-show-slide (for accordion panels)
 */
import VShowSlide from 'v-show-slide'
Vue.use(VShowSlide);

/**
 * vue-js-modal
 */
import VModal from 'vue-js-modal';
Vue.use(VModal);

/**
 * Add takeAtLeast to Promise
 */
Promise.delay = function (time) {
    return new Promise((resolve, reject) => { setTimeout(resolve, time) })
}
Promise.prototype.takeAtLeast = function (time) {
    return Promise.all([this, Promise.delay(time)]).then(([result]) => result);
}

/**
 * Global Vue components
 */
Vue.component('form-row', require('./components/form-row.vue').default);
Vue.component('form-accordion', require('./components/form-accordion.vue').default);
Vue.component('home-accordion', require('./components/home-accordion.vue').default);
Vue.component('input-checkbox', require('./components/input-checkbox.vue').default);
Vue.component('input-date', require('./components/input-date.vue').default);
Vue.component('input-image', require('./components/input-image.vue').default);
Vue.component('input-file', require('./components/input-file.vue').default);
Vue.component('input-label', require('./components/input-label.vue').default);
Vue.component('input-money', require('./components/input-money.vue').default);
Vue.component('input-number', require('./components/input-number.vue').default);
Vue.component('input-percent', require('./components/input-percent.vue').default);
Vue.component('input-radio-boolean', require('./components/input-radio-boolean.vue').default);
Vue.component('input-radio-boolean-reactive', require('./components/input-radio-boolean-reactive.vue').default);
Vue.component('input-radio-multi', require('./components/input-radio-multi.vue').default);
Vue.component('input-select', require('./components/input-select.vue').default);
Vue.component('input-select-states', require('./components/input-select-states.vue').default);
Vue.component('input-text', require('./components/input-text.vue').default);
Vue.component('input-textarea', require('./components/input-textarea.vue').default);
Vue.component('alerts', require('./components/alerts.vue').default);
Vue.component('progress-indicator', require('./components/progress-indicator.vue').default);

/**
 * Vue components accessed in Blade templates
 */
import SignupButtonModal from './components/signup-button-modal.vue';

import AddToHomescreen from './components/add-to-homescreen.vue';
import ScrollToButton from './components/scroll-to-button.vue';

import DealStore from './deal-store.vue';

import SidebarSlider from './nav/sidebar-slider.vue';

import BrokerNav from './nav/broker-nav.vue';
import ContactUserNav from './nav/contact-user-nav.vue';
import ClientNav from './nav/client-nav.vue';

import NewProperty from './broker/new-property.vue';
import FreeTrialBanner from './broker/free-trial-banner.vue';
import FreeTransactionBanner from './broker/free-transaction-banner.vue';
import TrialExpiredBanner from './broker/trial-expired-banner.vue';
import ShareRequestBanner from './broker/share-request-banner.vue';

import DashboardIndex from './broker/dashboard/dashboard-index.vue';
import DashboardSharedIndex from './broker/dashboard/dashboard-shared-index.vue';
import DashboardSharedDetail from './broker/dashboard/dashboard-shared-detail.vue';
import DashboardProperty from './broker/dashboard/dashboard-property.vue';

import ContactsIndex from './broker/contacts/contacts-index.vue';

import OnboardingIndex from './broker/onboarding/onboarding-index.vue';

import SettingsContactInformationIndex from
    './broker/profile/settings/contact-information/contact-information-index.vue';
import SettingsHomeOfficeIndex from
    './broker/profile/settings/home-office/home-office-index.vue';
import SettingsTransactionDefaultsIndex from
    './broker/profile/settings/transaction-defaults/transaction-defaults-index.vue';
import SettingsPasswordIndex from
    './broker/profile/settings/password/password-index.vue';
import SettingsSharedAccountsIndex from
    './broker/profile/settings/account/shared-accounts-index.vue';

import ProfilePropertiesIndex from './broker/profile/properties/properties-index.vue';

import AgentBrokersIndex from './deal/agent-brokers/agent-brokers-index.vue';
import BrokerFinancialsIndex from './deal/broker-financials/broker-financials-index.vue';
import BuyerInformationIndex from './deal/buyer-information/buyer-information-index.vue';
import ContractInformationIndex from './deal/contract-information/contract-information-index.vue';
import HomeOfficeIndex from './deal/home-office/home-office-index.vue';
import ListingInformationIndex from './deal/listing-information/listing-information-index.vue';
import PropertyTypeIndex from './deal/property-type/property-type-index.vue';
import SellerInformationIndex from './deal/seller-information/seller-information-index.vue';
import TransactionFinancialsIndex from './deal/transaction-financials/transaction-financials-index.vue';
import TransactionNotesIndex from './deal/transaction-notes/transaction-notes-index.vue';

// Commercial
import CommercialContractInformationIndex from './deal/commercial/contract-information/contract-information-index.vue';
import CommercialTaxesInsuranceIndex from './deal/commercial/taxes-insurance/taxes-insurance-index.vue';
import CommercialTenantRosterIndex from './deal/commercial/tenant-roster/tenant-roster-index.vue';
import CommercialLongTermObligationsIndex from './deal/commercial/long-term-obligations/long-term-obligations-index.vue';
import CommercialUtilitiesContractsIndex from './deal/commercial/utilities-contracts/utilities-contracts-index.vue';
import CommercialTitleIndex from './deal/commercial/title/title-index.vue';
import CommercialZoningIndex from './deal/commercial/zoning/zoning-index.vue';
import CommercialRoadsIndex from './deal/commercial/roads/roads-index.vue';

import BuyerDashboardIndex from './buyer/dashboard/dashboard-index.vue';
import BuyerContractInformationIndex from './buyer/contract-information/contract-information-index.vue';
import BuyerProfileIndex from './buyer/buyer-profile/buyer-profile-index.vue';
import DocumentsIndex from './buyer/documents/documents-index.vue';
import DocumentViewerEntry from './buyer/documents/document-viewer-entry.vue';
import SignaturesIndex from './buyer/documents/signatures/signatures-index.vue';
import PropertyIndex from './buyer/property/property-index.vue';
import MortgageIndex from './buyer/mortgage/mortgage-index.vue';
import InspectionIndex from './buyer/inspection/inspection-index.vue';
import AttorneyIndex from './buyer/attorney/attorney-index.vue';
import InsuranceIndex from './buyer/insurance/insurance-index.vue';
import ClosingIndex from './buyer/closing/closing-index.vue';

import LandingNavButtons from './landing/landing-nav-buttons.vue';
import LandingNavMenus from './landing/landing-nav-menus.vue';
import LandingNavFooter from './landing/landing-nav-footer.vue';

import TestimonialCarousel from './components/testimonial-carousel.vue';

import { initI18n } from './i18n';

/**
 * Boot Vue app
 */
if (document.getElementById('app')) {
    require('./store.js');

    const app = initI18n().then(function (i18n) {
        return new Vue({
            el: '#app',
            i18n,
            components: {
                SignupButtonModal,

                AddToHomescreen,
                ScrollToButton,

                DealStore,

                SidebarSlider,

                BrokerNav,
                ContactUserNav,
                ClientNav,

                NewProperty,
                FreeTrialBanner,
                FreeTransactionBanner,
                TrialExpiredBanner,
                ShareRequestBanner,

                DashboardIndex,
                DashboardSharedIndex,
                DashboardSharedDetail,
                DashboardProperty,
                ProfilePropertiesIndex,

                ContactsIndex,

                OnboardingIndex,

                SettingsContactInformationIndex,
                SettingsHomeOfficeIndex,
                SettingsTransactionDefaultsIndex,
                SettingsPasswordIndex,
                SettingsSharedAccountsIndex,

                AgentBrokersIndex,
                BrokerFinancialsIndex,
                BuyerInformationIndex,
                ContractInformationIndex,
                HomeOfficeIndex,
                ListingInformationIndex,
                PropertyTypeIndex,
                SellerInformationIndex,
                TransactionFinancialsIndex,
                TransactionNotesIndex,

                CommercialContractInformationIndex,
                CommercialTaxesInsuranceIndex,
                CommercialTenantRosterIndex,
                CommercialLongTermObligationsIndex,
                CommercialUtilitiesContractsIndex,
                CommercialTitleIndex,
                CommercialZoningIndex,
                CommercialRoadsIndex,

                BuyerDashboardIndex,
                BuyerContractInformationIndex,
                BuyerProfileIndex,
                DocumentsIndex,
                DocumentViewerEntry,
                SignaturesIndex,
                PropertyIndex,
                MortgageIndex,
                InspectionIndex,
                AttorneyIndex,
                InsuranceIndex,
                ClosingIndex,

                LandingNavButtons,
                LandingNavMenus,
                LandingNavFooter,

                TestimonialCarousel,
            },
        });
    });
}
